import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Les dates de l'API arrivent en UTC sans marqueur de fuseau ("2026-06-17T12:37:25") :
// on les marque explicitement UTC pour que le navigateur les convertisse en heure locale.
export function parseApiDate(value) {
  if (!value) return null;
  if (typeof value === "string" && !/(?:[Zz]|[+-]\d{2}:?\d{2})$/.test(value)) {
    return new Date(value + "Z");
  }
  return new Date(value);
}

// --- Configuration de l'agenda (horaires d'ouverture, absences) ---

export const AGENDA_DAYS = [
  { key: "lundi", label: "Lundi" },
  { key: "mardi", label: "Mardi" },
  { key: "mercredi", label: "Mercredi" },
  { key: "jeudi", label: "Jeudi" },
  { key: "vendredi", label: "Vendredi" },
  { key: "samedi", label: "Samedi" },
  { key: "dimanche", label: "Dimanche" },
];

export const DEFAULT_OPENING_HOURS = {
  lundi: { open: true, ranges: [{ start: "09:00", end: "17:00" }] },
  mardi: { open: true, ranges: [{ start: "09:00", end: "17:00" }] },
  mercredi: { open: true, ranges: [{ start: "09:00", end: "17:00" }] },
  jeudi: { open: true, ranges: [{ start: "09:00", end: "17:00" }] },
  vendredi: { open: true, ranges: [{ start: "09:00", end: "17:00" }] },
  samedi: { open: false, ranges: [{ start: "09:00", end: "12:00" }] },
  dimanche: { open: false, ranges: [{ start: "09:00", end: "12:00" }] },
};

// Accepte l'ancien format { open, start, end } et le nouveau { open, ranges: [...] }
export function normalizeOpeningHours(raw) {
  const out = {};
  for (const { key } of AGENDA_DAYS) {
    const d = raw?.[key];
    if (d?.ranges?.length) {
      out[key] = { open: !!d.open, ranges: d.ranges };
    } else if (d) {
      out[key] = {
        open: !!d.open,
        ranges: [{ start: d.start || "09:00", end: d.end || "17:00" }],
      };
    } else {
      out[key] = DEFAULT_OPENING_HOURS[key];
    }
  }
  return out;
}

// Plages de rendez-vous confiées à la secrétaire IA.
// Par défaut (jamais définies), ce sont les horaires d'ouverture du cabinet.
export function bookingHoursOf(settings) {
  return normalizeOpeningHours(settings?.booking_hours || settings?.opening_hours);
}

// Renvoie l'absence couvrant la date ISO (YYYY-MM-DD), ou null
export function findAbsence(iso, absences) {
  return (
    (absences || []).find(
      (a) => a.start_date && a.end_date && a.start_date <= iso && iso <= a.end_date
    ) || null
  );
}
